import { css } from 'styled-components';

const replacementOverlayOpacity = 0.5;
const errorBorderRgb = '255, 0, 0';
const errorBorderOpacityFull = 0.8;
const introJsButtonText = '#333';

/**
 * We need to workaround the issue for fixed elements:
 *  - https://github.com/usablica/intro.js/issues/109#issuecomment-365277501
 *
 * The issue is as follows:
 *   z-index's don't work well for fixed elements unless they are siblings.
 *   IntroJs inserts its background overlay + "under-box" overlay at the end of the
 *   page and then raises up our targeted element with z-index.
 *
 *   However, since some targets are fixed or deep children of fixed elements,
 *   this causes the "raised" element to remain underneath both overlays. The
 *   result is our target is covered by a the dark overlay + white "under-box".
 *   Our solution essentially gets rid of the "background overlay" and, instead,
 *   creates an overlay with a hole in it. We could use modern CSS with:
 *   ```
 *   .introjs-helperLayer {
 *     mix-blend-mode: overlay !important;
 *   }
 *   ```
 *   but this results in a darker/duller image than the original and may be fussy
 *   with browser support.
 */
export const fixedElementCssWorkaround = css`
  .fixed-element-disable-background.introjs-helperLayer {
    background: transparent;
  }

  .introjs-overlay {
    display: invisible;
  }

  /* Our replacement overlay background. */
  .introjs-helperLayer:before {
    opacity: 0;
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    border-radius: 0.25em;
    box-shadow: 0 0 0 1000em rgba(0, 0, 0, ${replacementOverlayOpacity});
    opacity: 1;
  }
`;

export const customizeIntroJsStyle = css`
  .introjs-tooltip .introjs-button.introjs-skipbutton {
    color: ${introJsButtonText};
  }

  @keyframes introJsFadeError {
    0% {
      border-color: rgba(${errorBorderRgb}, ${errorBorderOpacityFull});
    }
    50% {
      border-color: rgba(${errorBorderRgb}, 0.5);
    }
    100% {
      border-color: rgba(${errorBorderRgb}, ${errorBorderOpacityFull});
    }
  }

  /* If the user isn't following the tour. */
  .introjs-tour-error.introjs-helperLayer:before {
    animation: introJsFadeError linear 0.25s 2 forwards;
    border: 0.1em solid rgba(${errorBorderRgb}, ${errorBorderOpacityFull});
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/OnboardingTour/OnboardingTour.style.js